import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/AuthContext";
import Landing from "@/pages/Landing";
import BookRoom from "@/pages/BookRoom";
import BookingConfirmation from "@/pages/BookingConfirmation";
import BookingLookup from "@/pages/BookingLookup";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import DashboardPage from "@/pages/admin/DashboardPage";
import BookingsPage from "@/pages/admin/BookingsPage";
import RoomTypesPage from "@/pages/admin/RoomTypesPage";
import RoomUnitsPage from "@/pages/admin/RoomUnitsPage";
import CheckInPage from "@/pages/admin/CheckInPage";
import ExpensesPage from "@/pages/admin/ExpensesPage";
import HousekeepingPage from "@/pages/admin/HousekeepingPage";
import ReviewsPage from "@/pages/admin/ReviewsPage";
import ActivitiesPage from "@/pages/admin/ActivitiesPage";
import HotelServicesPage from "@/pages/admin/HotelServicesPage";
import ServiceBookingsPage from "@/pages/admin/ServiceBookingsPage";
import ServiceQuotesPage from "@/pages/admin/ServiceQuotesPage";
import QuoteStatus from "@/pages/QuoteStatus";
import SettingsPage from "@/pages/admin/SettingsPage";
import ReportsPage from "@/pages/admin/ReportsPage";
import UsersPage from "@/pages/admin/UsersPage";

function AdminHome() {
  const { user } = useAuth();
  if (user?.role === "receptionist") return <Navigate to="/admin/bookings" replace />;
  return <Navigate to="/admin/dashboard" replace />;
}

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[color:var(--sand)]">
        <p className="font-ui text-sm text-[color:var(--muted-text)]">Loading…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/book/:typeId" element={<BookRoom />} />
            <Route path="/booking/:reference" element={<BookingConfirmation />} />
            <Route path="/lookup" element={<BookingLookup />} />
            <Route path="/quote/:reference" element={<QuoteStatus />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}
            >
              <Route index element={<AdminHome />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="bookings" element={<BookingsPage />} />
              <Route path="checkin" element={<CheckInPage />} />
              <Route path="room-types" element={<RoomTypesPage />} />
              <Route path="room-units" element={<RoomUnitsPage />} />
              <Route path="housekeeping" element={<HousekeepingPage />} />
              <Route path="expenses" element={<ExpensesPage />} />
              <Route path="reviews" element={<ReviewsPage />} />
              <Route path="activities" element={<ActivitiesPage />} />
              <Route path="services" element={<HotelServicesPage />} />
              <Route path="service-bookings" element={<ServiceBookingsPage />} />
              <Route path="quotes" element={<ServiceQuotesPage />} />
              <Route path="reports" element={<ReportsPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="users" element={<UsersPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
